/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TriggerEventType {
  SelfCheckinDriverWaiting = 'self_checkin_driver_waiting'
}
